<template>
    <div>
        <theme-stacked-bar-chart
            :categories="categories"
            :datasets="chartDatasets"
            :y-axis-label="'Square Footage'"
            :y-axis-max-value="yAxisMaxValue"
            :format-value="formatValue"
        />
    </div>
</template>

<script>
    import ThemeStackedBarChart from './charts/ThemeStackedBarChart.vue';

    export default {
        name: 'StackChart',
        
        components: {
            ThemeStackedBarChart
        },

        props: {
            data: {
                type: [Array, Object],
                required: true
            },

            isSite: {
                type: Boolean,
                required: false
            }
        },
        
        data() {
            return {
                isDarkMode: document.documentElement.classList.contains('dark')
            }
        },

        methods: {
            characterRange(startChar, endChar) {
                return String.fromCharCode(..._.range(startChar.charCodeAt(0), endChar.charCodeAt(0) + 1)).split('').reverse()
            },

            formatValue(value) {
                // Format as K (thousands)
                if (value >= 1000) {
                    return (value / 1000).toFixed(1) + 'K';
                }
                return value.toLocaleString();
            }
        },

        computed: {
            categories() {
                return this.buildingFloors;
            },

            chartDatasets() {
                return _.map(this.dataSetNames, (dataset) => {
                    return {
                        label: dataset.name.toUpperCase(),
                        color: dataset.color,
                        data: _.map(this.buildingFloors, (floor) => {
                            if (this.data[floor] != undefined) {
                                return this.data[floor][dataset.name] ? this.data[floor][dataset.name] : 0;
                            }
                            return 0;
                        })
                    }
                });
            },

            buildingFloors() {
                var numericBuildingFloors = _.map(_.range(0, this.topFloor), (num) => {
                    return num + 1;
                }).reverse()

                if (this.nonNumericBuildingFloors.length) {
                    if (this.nonNumericBuildingFloors[0] != "LL") {
                        return _.concat(numericBuildingFloors, this.characterRange("A", this.nonNumericBuildingFloors[0]))
                    }

                    return _.concat(numericBuildingFloors, this.nonNumericBuildingFloors);
                }

                return numericBuildingFloors;
            },

            nonNumericBuildingFloors() {
                return _.filter(_.keys(this.data), (key) => { return ! parseInt(key) }).sort().reverse();
            },

            dataSetNames() {
                // Adjust colors for dark mode to match Figma
                const occupiedColor = this.isDarkMode ? '#475569' : '#DAE1E7';
                
                if (this.isSite) {
                    return [
                        { color: '#3b82f6', name: 'Your Space' },
                        { color: '#10b981', name: 'Available' },
                        { color: occupiedColor, name: 'Occupied' },
                    ]
                }

                return [
                    { color: '#10b981', name: 'Available' },
                    { color: occupiedColor, name: 'Occupied' },
                ]
            },

            yAxisMaxValue() {
                return _.max(_.map(_.map(this.data, _.values), _.sum));
            },

            topFloor() {
                return _.maxBy(_.keys(this.data), function(key) { return isNaN(parseInt(key)) ? key : parseInt(key); });
            }
        },
    }
</script>
